import { render, staticRenderFns } from "./ShowDetail.vue?vue&type=template&id=2478f25c"
import script from "./ShowDetail.vue?vue&type=script&lang=js"
export * from "./ShowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports